import Marker from './Marker';

export default Marker;
